import * as React from "react";
import { Nav, Accessibility } from "../frame";
import * as cls from "./Navbar.module.scss";
import Dropdown from "../component/DropDown";
import { useSelector } from "react-redux";
import MiniModalNotifications from "../component/MiniModalNotifications";
export { Navbar };
/**
 * Загружает и отображает панель навигации.
 * @param {Object} props - Атрибуты элемента.
 * @param {Action[]} [props.menu] - Дополнительные пункты меню.
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link StudioFrame.jsx}, {@link ../frame/Action.jsx}
 * @author Айдарбек Артур уулу <kulubaev97@gmail.com>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Navbar({ menu = [], handleSignOut }) {
  const [open, setOpen] = React.useState(false);
  const { contracts } = useSelector((state) => state.contract);
  const { count } = useSelector((state) => state.notifications);

  const frameNav = [
    ...menu,
    Accessibility.OPEN,
    {
      icon: "bell",
      name: "Уведомления",
      badge: count.count,
      onClick: (event) => {
        event.preventDefault();
        setOpen((prev) => !prev);
      },
    },
    {
      icon: "exit",
      name: "Выход",
      delimiter: true,
      onClick: (event) => {
        event.preventDefault();
        handleSignOut();
      },
    },
  ];
  return (
    <div className={cls.studio_navbar_container}>
      <nav className={cls.studio_navbar}>
        {contracts && (
          <Dropdown onChange={(value) => value} isSearchable={false} />
        )}
        <Nav menu={frameNav} />
        {open && (
          <MiniModalNotifications
            openMiniModal={open}
            setOpenMiniModal={setOpen}
          />
        )}
      </nav>
      <Accessibility />
    </div>
  );
}
